import { call, put, takeEvery } from 'redux-saga/effects';
import { createOrder } from '../../requests/create_order_request';
import { createOrderRequestSuccess, createOrderRequestFailure } from '../actions/create_order.actions';
import { CREATE_ORDER_REQUEST } from '../constants/create_order.constants';
import { message_success } from '../../../../../components/Message';
// import { getLeadProfile } from "../../requests/get_lead_profile_request";

function* createOrderSagaRequest({
    id, kind, date_from, date_to,
}) {
    const {
        result, msg, error, options,
    } = yield call(createOrder, id, kind, date_from, date_to);
    if (result) {
        yield put(createOrderRequestSuccess(options));
        message_success(msg);
    } else {
        yield put(createOrderRequestFailure(error));
    // message_error(error);
    }
}

export default function* createOrderTransportSaga() {
    yield takeEvery(CREATE_ORDER_REQUEST, createOrderSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/create_order.saga.js